import React from 'react';
import { Button, Grid2 as Grid, Box } from '@mui/material';
import useCart from '../../hooks/useCart';
import { CART_TABS } from '../../utils/constants';

const SwitchCart = () => {
    const { tab, setTab } = useCart();

    const handleTab = (tabName) => () => {
        setTab(tabName);
    };

    // const cartCount = (cart) => {
    //     if (cart.length < 1) return null;
    //     return <Chip label={cart.length} size="small" variant="outlined" style={{fontSize: '10px', border: '2px solid', fontWeight: 'bold'}} />;
    // };

    return (
        <Box sx={{ width: '100%' }}>
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                <Grid size={6}>
                    {/* <Button fullWidth variant='contained' disabled={tab === CART_TABS.TESTS} onClick={handleTab(CART_TABS.TESTS)} endIcon={cartCount(testCart)}>Tests</Button> */}
                    <Button fullWidth variant='contained' disabled={tab === CART_TABS.TESTS} onClick={handleTab(CART_TABS.TESTS)}>Tests</Button>
                </Grid>
                <Grid size={6}>
                    <Button fullWidth variant='contained' disabled={tab === CART_TABS.MEDS} onClick={handleTab(CART_TABS.MEDS)}>Medicines</Button>
                </Grid>
            </Grid>
        </Box>
    );
};

export default SwitchCart;